import { Link } from 'react-router-dom';
import { contactInfo } from '@/mocks/aboutData';

const footerLinks = [
  {
    title: '视频分类',
    links: [
      { name: '电影', path: '/category/movie' },
      { name: '电视剧', path: '/category/tv' },
      { name: '综艺', path: '/category/variety' },
      { name: '动漫', path: '/category/anime' },
      { name: '纪录片', path: '/category/documentary' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌故事', path: '/about' },
      { name: '用户评价', path: '/about#testimonials' },
      { name: '常见问题', path: '/about#faq' },
      { name: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '合作平台',
    links: [
      { name: '西瓜视频免费', path: '/category/movie' },
      { name: '小蓝视频', path: '/category/variety' },
      { name: '茄子视频', path: '/category/anime' },
      { name: '芒果视频', path: '/category/tv' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-display text-xl text-background-50">糖豆视频</span>
              </Link>
              <p className="text-secondary-400 text-sm leading-relaxed mb-4">
                糖豆视频免费在线观看平台，聚合西瓜视频免费、小蓝视频、茄子视频、芒果视频等站最新电影电视剧综艺资源，内容更新快高清流畅不卡顿。
              </p>
              <div className="flex items-center gap-3">
                <a href={`mailto:${contactInfo.email}`} className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer text-secondary-300 hover:text-background-50" aria-label="邮箱">
                  <i className="ri-mail-line text-sm"></i>
                </a>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer text-secondary-300 hover:text-background-50" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer text-secondary-300 hover:text-background-50" aria-label="QQ">
                  <i className="ri-qq-line text-sm"></i>
                </span>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-background-100 text-base font-semibold mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-secondary-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-secondary-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-secondary-500 text-xs">
              &copy; 2020 - {new Date().getFullYear()} 糖豆视频 TangDou Video. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-secondary-500 text-xs cursor-pointer hover:text-background-50 transition-colors">隐私政策</span>
              <span className="text-secondary-500 text-xs cursor-pointer hover:text-background-50 transition-colors">用户协议</span>
              <span className="text-secondary-500 text-xs cursor-pointer hover:text-background-50 transition-colors">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}